
  <div class="container-questions">
    <div class="hor-div">Preguntas frecuentes</div>
    <div class="hor2-div">
      <section class="accordion" *ngFor="let resultado of faqs">
        <div class="x">
          <div class="container">
              <div class="horizontal-div-left" (click)="openDiv(resultado.id)"> {{resultado.question}}
              </div>
              <div class="horizontal-div-right">
                <img [src]="!buttonSelection[resultado.id] ? '/assets/icono/cross.svg':'/assets/icono/less.svg'" alt="img" />
              </div>
        </div>
        <div  *ngIf="openmodal === resultado.id" >
        <div class="horizontal-inferior"[innerHTML]="resultado.answer"></div>
        <div *ngIf="resultado.link.length>0">
          <a href="{{ resultado.link }}"><p class="link-externo"><strong>Link externo  </strong><img src="/assets/icono/arrow-left.svg" alt=""/></p></a>
        </div>
      </div> </div>   
    </section>
  </div>
  
</div>
  



